const style = (theme): any => ({});
export default style;
